import React, { useEffect, useState, useContext } from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';

import ModifySearchForm from './ModifySearchForm';
import SubMenu from './SubMenu/SubMenu';
import { getMenuAction } from '../../../../redux/actions/subMenuAction';
// import omniture from '../../../../tracker/omniture';
import ExploreIcon from '../../../../../common/assets/svg/explore';
import ThemeContext from '../../../../../common/context/themeContext';
import { COLLECTION_PAGE_NAME } from '../../../../../common/src/constants';
import { getMMT_HLD_OBJ } from '../../../../../common/utils/appUtils';
import {
  dateFormatter,
  isAgentLoggedIn,
  getUrlParamsMapV2,
  changeWindowUrl,
} from '../../../../../common/utils/browserUtils';
import GridIcon from '../../../../../common/assets/svg/grid';
import LineIcon from '../../../../../common/assets/svg/lineQuery';
import {
  NotificationIcon,
  NotificationReadIcon,
} from '../../../../../common/assets/svg/NotificationsIcons';
import {
  LISTING_PAGE_NAME,
  COLLECTIONS_PAGE_NAME,
} from '../../../../../common/constants/appConstant';
import OmnitureUtils from '../../../../../common/utils/Omniture/OmnitureUtils';
import { faOnExploreClick } from '../analytics-services';
import './ModifySearchContainer.css';

const isListingPage = LISTING_PAGE_NAME === getUrlParamsMapV2().redirectionPage;

const AgentSection = loadable(
  () =>
    import(/* webpackChunkName: 'AgentDashboard' */ '../../../../../common/component/AgentSection')
);

const omniture = {
  captureOmnitureClick: () => {},
};

const ModifySearchContainer = props => {
  const [showMenu, toggleShowMenu] = useState(false);
  const {
    getMenu,
    headerMenu,
    branch,
    fromCity,
    toCity,
    travelDate,
    handleMFS,
    handleCloseMFS,
    modifySearchActive,
    blockerNotificationsCount = 0,
    setNotificationsPanel = false,
  } = props;
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    if (!isAgentLoggedIn() && !getMMT_HLD_OBJ().fromSEO) {
      getMenu();
    }
  }, []);

  const changeListingType = redirectionPage => {
    changeWindowUrl({ redirectionPage }, true);
  };

  const renderAgentSection = () => {
    if (isAgentLoggedIn() === false || getMMT_HLD_OBJ().fromSEO === true) {
      return null;
    }
    const config = {
      departureCity: fromCity,
      tagDestination: toCity,
      page: COLLECTION_PAGE_NAME,
      menuList: ['User Info', 'Quotations'],
      activeTab: 'Quotations',
      handleSetTicketId: () => {},
      omniture: {
        params: branch,
        clickHandler: omniture.captureOmnitureClick,
      },
    };
    if (travelDate !== '') {
      config.travelDate = dateFormatter(travelDate, 'YYYY-MM-DD');
    }
    return (
      <div className="agentRight">
        <div className="agentCollection">
          <ul className="agentCollectionBox">
            <li
              className="Selection"
              onClick={() => {
                changeListingType(LISTING_PAGE_NAME);
              }}
            >
              <div className="tooltipViewType">
                <LineIcon color={isListingPage ? '#008cff' : 'white'} height="32" width="32" />
              </div>
              <div className="tooltipViewTypeContainer">{LISTING_PAGE_NAME}</div>
            </li>
            <li
              className="Selection"
              onClick={() => {
                changeListingType(COLLECTIONS_PAGE_NAME);
              }}
            >
              <div className="tooltipViewType">
                <GridIcon color={isListingPage ? 'white' : '#008cff'} />
              </div>
              <div className="tooltipViewTypeContainer">{COLLECTIONS_PAGE_NAME}</div>
            </li>
            <li className="Selection" onClick={() => setNotificationsPanel(true)}>
              <div className="notification-icon">
                {blockerNotificationsCount > 0 ? <NotificationIcon /> : <NotificationReadIcon />}
                <span className="notification-badge">{blockerNotificationsCount}</span>
              </div>
            </li>
          </ul>
        </div>
        <AgentSection config={config} />
      </div>
    );
  };

  return (
    <div className="makeFlex spaceBetween hrtlCenter listing-modifysearch_wrapper">
      <div className={'listing-modifysearch_container'}>
        <div id="modifySearch" className="listing-modifysearch_inner">
          {showMenu ? (
            <SubMenu menuList={headerMenu} />
          ) : (
            <>
              <ModifySearchForm
                handleMFS={handleMFS}
                handleCloseMFS={handleCloseMFS}
                modifySearchActive={modifySearchActive}
              />
            </>
          )}
        </div>
        {renderAgentSection()}
        {!!headerMenu.length && (
          <div
            id="explore"
            className="noExplore"
            onClick={() => {
              faOnExploreClick(showMenu);
              OmnitureUtils.trackClickEvent({
                prop54: showMenu ? 'Menu_Collapse' : 'Menu_Expand',
              });
              toggleShowMenu(!showMenu);
            }}
          >
            {!!headerMenu.length && showMenu ? (
              <a className="closeExplore" href="#">
                Close Explore
                <span className="holidaySprite exploreClose" />
              </a>
            ) : (
              <a className="font14 latoBold explore-link" href="#">
                <ExploreIcon color={theme.colors.exploreLinksColor} />
                <span className="explore-text">Explore</span>
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const { subMenu, search, metadata } = state;
  return {
    headerMenu: subMenu.headerMenu || [],
    search,
    branch: metadata?.branch,
    fromCity: search.default.fromCity,
    toCity: search.default.toCity,
    travelDate: search.default.travelDate,
  };
};

const mapDispatchToProps = {
  getMenu: getMenuAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModifySearchContainer);
